// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-cover-img[data-v-19689818]{position:relative;width:100%;overflow:hidden}.article-cover-img img[data-v-19689818]{position:absolute;width:100%;height:100%;z-index:1;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.article-cover-img .article-cover-img__placeholder[data-v-19689818]{display:block;width:100%;pointer-events:none;z-index:0;padding-top:52.33333%}", ""]);
// Exports
module.exports = exports;
